import { render, staticRenderFns } from "./AIGeneratedTypeAnswerContent.vue?vue&type=template&id=1c87f6f8&"
import script from "./AIGeneratedTypeAnswerContent.vue?vue&type=script&lang=js&"
export * from "./AIGeneratedTypeAnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./AIGeneratedTypeAnswerContent.vue?vue&type=style&index=0&id=1c87f6f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports